import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import "../../src/helper/Header.css"
import { FaFacebookSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaInstagramSquare } from "react-icons/fa";


function useHeader() {

	const scrollToTop = () => {
		window.scrollTo({
		  top: 0,
		  behavior: "smooth",
		});
	  };
    return (
        <>
 <footer>
        <div className="top-line-theme"></div>
        <div className="row">
          <div className=" col-lg-12">
            <div className="row footer-right-links">
              <div className="col-lg-3">
                <h6>Text & Document Translation</h6>
                <ul>
                  <li className="drop-menu-item">
                    <a href="https://translation.aicte-india.org/translation-independent/"  target="_blank">
                      Online Document Translation Tool including Online Editor
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a href="https://translation.aicte-india.org/translation-independent/Text-Editor/"  target="_blank">
                      Chutki
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a href="https://anuvadiniqa.aicte-india.org/"  target="_blank">Ananta</a>
                  </li>
                  <li className="drop-menu-item">
                    <a href="https://anuvadini.aicte-india.org/voiceform/"  target="_blank">
                      Voice Based Multilingual Form
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a href="https://translation.aicte-india.org/translation-independent/PmModiNationalInternshipPortal/"  target="_blank">
                      Video Translation
                    </a>
                  </li>

                  <li className="drop-menu-item">
                    <a href="https://translation.aicte-india.org/translation-independent/transliterate/"  target="_blank">
                      Virtual Keyboard
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a href="https://anuvadini.aicte-india.org/govtofindiascheme/"  target="_blank">
                      Govt of Bharatiya Schemes & Initiatives Voice Based Search
                    </a>
                  </li>

                  <li className="drop-menu-item">
                    <a href="https://anuvadini.aicte-india.org/dictation-tool/"  target="_blank">
                      Dictation Tool
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a href="https://anuvadini.aicte-india.org/lawdictionary/"  target="_blank">
                      Legal Glossary
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a href="https://anuvadini.aicte-india.org/Bhasha-daan/" target="_blank">
                      Bhasha Daan
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2">
                <h6>Video</h6>
                <ul>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://bharattube.aicte-india.org/session"
                    >
                      Bharat Audio Live
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://bharattube.aicte-india.org/stream"
                    >
                      Bharat Video Live
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://bharattube.aicte-india.org/realtimeVideo"
                    >
                      BharatTube
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://speech.aicte-india.org/"
                    >
                      Bharat Messenger
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/immersive-ai"
                    >
                      Immersive AI
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/video/"
                    >
                      AI Video Analyzer
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/youtube-analyzer/"
                    >
                      AI Youtube-Video Analyser
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-2">
                <h6>Voice</h6>
                <ul>
                  <li className="drop-menu-item">
                    <a href="https://voice.aicte-india.org/"  target="_blank">Bhashin</a>
                  </li>
                  <li className="drop-menu-item">
                    <a href="https://voice.aicte-india.org/" target="_blank">
                      Text to Text Translation
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a href="https://anuvadini.aicte-india.org/ThreeDAudio" target="_blank" onClick={scrollToTop}>
                      3D Audio
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/AutoPartner" target="_blank" onClick={scrollToTop}>
                      {" "}
                      Auto Panner
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/BassBooster" target="_blank" onClick={scrollToTop}>
                      Bass Booster
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/Equalizer" target="_blank" onClick={scrollToTop}>
                      Equalizer
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/NoiseReducer" target="_blank" onClick={scrollToTop}>
                      Noise Reducer
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/PitchShifter" target="_blank" onClick={scrollToTop}>
                      Pitch Shifter
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/Reverb" target="_blank" onClick={scrollToTop}>
                      Reverb
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/reverseAudio" target="_blank" onClick={scrollToTop}>
                      Reverse Audio
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/stereoPanner" target="_blank" onClick={scrollToTop}>
                      Stereo Panner
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/tempoChanger" target="_blank" onClick={scrollToTop}>
                      Tempo Changer
                    </a>
                  </li>
                  {/* <li className="drop-menu-item"><Link to="/trimmerCutter"> Trimmer / Cutter</Link></li> */}
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/vocalRemover" target="_blank" onClick={scrollToTop}>
                      Vocal Remover
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a to="https://anuvadini.aicte-india.org/volumeChanger" target="_blank" onClick={scrollToTop}>
                      {" "}
                      Volume Changer
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a target="_blank" href="https://bhashin.aicte-india.org/">
                      {" "}
                      Speech Messenger
                    </a>
                  </li>
                </ul>
                <br />
                {/* <h6>Meeting</h6>
                    <ul>
                        <li className="drop-menu-item"><a href="https://translation.aicte-india.org/translation-independent/transliterate/">Virtual Keyboard</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>Screen Recording</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>Video Recording</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>Meeting Capture</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>Multi-Camera Recording</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>Phone as Webcam</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>Teleprompter</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>Remove Camera Background</Link></li>
                    </ul>
                    <br/> */}
              </div>
              <div className="col-lg-2">
                <h6>File</h6>
                <ul>
                  {/* <li className="drop-menu-item"><Link to={undefined}>PDF</Link></li> */}
                  <li className="drop-menu-item">
                    <a href="https://anuvadini.aicte-india.org/mkb100/" target="_blank">
                      Mann ki baat (100th episode celebration) Citizen feedback
                      Form
                    </a>
                  </li>
                </ul>
                <br />
                <h6>Education</h6>
                <ul>
                  <li className="drop-menu-item">
                    <a href="https://anuvadini.aicte-india.org/core-engg" target="_blank" onClick={scrollToTop}>
                      Core Engineering AI
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <Link to={undefined}>Killer - CV</Link>
                  </li>
                </ul>
                <br />
                <h6>Image</h6>
                <ul>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/speakPic/"
                      onClick={scrollToTop}
                    >
                      SpeakPic
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/JaduiDarpan/"
                      onClick={scrollToTop}
                    >
                      JaduiDarpan
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/HandwrittenAI/"
                      onClick={scrollToTop}
                    >
                      Handwritten AI
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/image-editor/ImageBackgroundRemover"
                      onClick={scrollToTop}
                    >
                      Image Background Remover
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/image-editor/imagecaption"
                      onClick={scrollToTop}
                    >
                      Image Caption with Variation
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/image-editor/graytocolor"
                      onClick={scrollToTop}
                    >
                      Sketch Rendering
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/image-editor/photoToSketch"
                      onClick={scrollToTop}
                    >
                      Photo To Sketch
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/image-editor/hdUpscaler"
                      onClick={scrollToTop}
                    >
                      HD Upscaler
                    </a>
                  </li>
                  {/* <li className="drop-menu-item"><Link to="/ImageBackgroundRemover" onClick={scrollToTop}>Image Background Remover</Link></li>
                        <li className="drop-menu-item"><Link to="/RemoveUnwantedObjects" onClick={scrollToTop}>Remove Unwanted Objects</Link></li>
                        <li className="drop-menu-item"><Link to="/FaceCutout" onClick={scrollToTop}>Face Cutout</Link></li> */}
                </ul>
                {/* <h6>Video</h6>
                    <ul>
                        <li className="drop-menu-item"><Link to={undefined}>Video Background Remover</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>Video with Voice</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>Text to Video</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>AI Video Generator</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>AI Summary</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>Branding</Link></li>
                        <li className="drop-menu-item"><Link to={undefined}>AI Video Analyzer</Link></li>
                    </ul> */}
              </div>
              <div className="col-lg-2">
                <h6>PDF</h6>
                <ul>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/pdfeditor"
                      onClick={scrollToTop}
                    >
                      Merge PDF
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/splitPDF"
                      onClick={scrollToTop}
                    >
                      Split PDF
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/pdfcompress"
                      onClick={scrollToTop}
                    >
                      Compress PDF
                    </a>
                  </li>
                  {/* <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/pdfpagenum"
                      onClick={scrollToTop}
                    >
                      Add page numbers
                    </a>
                  </li> */}
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/Pdftoimages"
                      onClick={scrollToTop}
                    >
                      PDF to images
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/ProtectPdf"
                      onClick={scrollToTop}
                    >
                      Protect PDF
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/UnlockPDF"
                      onClick={scrollToTop}
                    >
                      Unlock PDF
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/TxttoPdf"
                      onClick={scrollToTop}
                    >
                      Txt to PDF
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/DocxtoPDF"
                      onClick={scrollToTop}
                    >
                      Docx to PDF
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/PpttoPdf"
                      onClick={scrollToTop}
                    >
                      PPT to PDF
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/ExceltoPdf"
                      onClick={scrollToTop}
                    >
                      Excel to PDF
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/PdftoTxt"
                      onClick={scrollToTop}
                    >
                      PDF to Text
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/PdftoDocx"
                      onClick={scrollToTop}
                    >
                      PDF to Docx
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/JpgtoPdf"
                      onClick={scrollToTop}
                    >
                      JPG to PDF
                    </a>
                  </li>
                  {/* <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/CreatePdf"
                      onClick={scrollToTop}
                    >
                      Create PDF
                    </a>
                  </li> */}
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/AddWatermark"
                      onClick={scrollToTop}
                    >
                      Add watermark
                    </a>
                  </li>
                  <li className="drop-menu-item">
                    <a
                      target="_blank"
                      href="https://anuvadini.aicte-india.org/pdf/ImagesfromPdf"
                      onClick={scrollToTop}
                    >
                      Extract PDF Images
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-1">
                <h6>Other Links</h6>
                <ul>
                  <li>
                    <a href="https://anuvadini.aicte-india.org/AboutUs" target='_blank'  title="About Us">
                      About Us
                    </a>
                  </li>
                  <li>
                    <a href="https://anuvadini.aicte-india.org/WhatIsAnuvadini"
					target='_blank'
                      onClick={scrollToTop}
                      title="About Us"
                    >
                      What is Anuvadini?
                    </a>
                  </li>
                  <li>
                    <a href="https://anuvadini.aicte-india.org/Contact"
					target='_blank'
                      onClick={scrollToTop}
                      title="Contact Us"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://anuvadini.aicte-india.org/blog/"
                      target="_blank"
                      onClick={scrollToTop}
                      title="Contact Us"
                    >
                      Anuvadini - Blog
                    </a>
                  </li>
                  <li>
				  <a
                      href="https://anuvadini.aicte-india.org/career/"
					  onClick={scrollToTop}
					  title="Career"
                      target="_blank" >Career</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <br />
        <hr />
        <br />
        <center>
        <ul className="socialMediaLst">
              <li><a href="https://www.linkedin.com/in/anuvadini-ai/" target="_blank"><FaLinkedin /></a></li>
              <li><a href="https://twitter.com/anuvadini" target="_blank"><FaSquareXTwitter /></a></li>
              <li><a href="https://www.facebook.com/profile.php?id=61558139695563" target="_blank"><FaFacebookSquare /></a></li>
              <li><a href="https://www.instagram.com/anuvadini_ai/" target="_blank"><FaInstagramSquare /></a></li>
            </ul>
          <div className="footer-links">
            <ul className="trmsLnkList">
              <li>
                <a
                  href="https://anuvadini.aicte-india.org/PrivacyPolicy"
                  title="Privacy Policy"
				   target="_blank"
                  onClick={scrollToTop}
                >
                  Privacy Policy
                </a>
              </li>
              |
              <li>
                <a href="https://anuvadini.aicte-india.org/tirmOfUse" title="Term of Use"  target="_blank" onClick={scrollToTop}>
                  Term of Use
                </a>
              </li>
              |
              <li>
                <a
                  href="https://anuvadini.aicte-india.org/cookies-policy"
                  title="Cookie Policy"
				   target="_blank"
                  onClick={scrollToTop}
                >
                  Cookie Policy
                </a>
              </li>
            </ul>
            
          </div>
        </center>
        <br />
        <center className='copyRgtTag'>
          © 2024 All rights reserved, Anuvadini AI, Ministry of Education, Government of India
          {/* <sup>®</sup> */}
        </center>
      </footer>
            {/* <footer>
                <div classNameName='bottomFoot'>
                <div classNameName="container-fluid">
                    <div classNameName="row justify-content-center">                        
                        <div classNameName="col-md-4 col-xs-12 ftrCntr">
                            <div classNameName="ftrLftIn ">
                            
                                <p classNameName='rights'>© 2023 <a href="https://www.aicte-india.org/" target="_blank" style={{color:"#ffd400"}}>AICTE</a> All Rights Reserved.</p>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </footer> */}
        </>
    )
}

export default useHeader;